import Typography from '@material-ui/core/Typography';
import get from 'lodash/get';
import moment from 'moment';
import { Subscribe } from 'unstated';

import Button from '~/components/Button';
import ConnectorsContainer from '~/containers/Connectors';
import history from '~/lib/history';

import styles from './Notification.style';
import SalesforceWarning from './SalesforceWarningIcon.svg';

const SalesforceWithWarningIcon = ({ classes, className }) => {
  return (
    <Subscribe to={[ConnectorsContainer]}>
      {(connectorsContainer) => {
        return (
          <div className={classnames(classes.notification, className)}>
            <div className={classes.notificationLogo}>
              <SalesforceWarning />
            </div>
            <div className={classes.notificationInfo}>
              <Typography className={classes.notificationTitle}>
                Salesforce has been disconnected.
              </Typography>
              <Typography className={classes.notificationMessage}>
                This segment needs access to fields in Salesforce. Reconnect
                Salesforce to restore this segment.
              </Typography>
            </div>
            <div className={classes.notificationActions}>
              <Typography className={classes.lastUpdated}>
                {moment(
                  get(
                    connectorsContainer.state.connectors,
                    'salesforce.updated_at',
                  ),
                ).calendar()}
              </Typography>
              <Button
                className={classes.notificationResolvebutton}
                variant="contained"
                onClick={() =>
                  history.push('/settings/configuration/salesforce')
                }>
                Fix this issue
              </Button>
            </div>
          </div>
        );
      }}
    </Subscribe>
  );
};

SalesforceWithWarningIcon.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SalesforceWithWarningIcon);
